import { render, staticRenderFns } from "./TemplateDesignerCard.vue?vue&type=template&id=a4e86580&"
import script from "./TemplateDesignerCard.vue?vue&type=script&lang=js&"
export * from "./TemplateDesignerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports